<template>
  <el-dialog title="电表关联设置" :visible.sync="meterVisible" width="1080px" :before-close="handleClose" :close-on-click-modal="false" left>
    <div v-if="parentVisible">
      <el-form :model="ruleForm" ref="ruleForm">
         <el-select v-model="ruleForm.parent" placeholder="请选择设父电表" style="width:200px;">
          <el-option v-for="(item,index) in parentList" :key="index" :label="item.meterName" :value="item.meter"/>
         </el-select>
         <el-select v-model="ruleForm.nodeFlag" placeholder="是否分项电表" style="width:100px;margin-left:20px;">
            <el-option label="是" value="yes" />
            <el-option label="否" value="no" />
         </el-select>
         <el-button type="primary" @click="submit" style="margin-left:20px;margin-right:20px;">确 定</el-button>
         <el-button @click="closeEdit">取 消</el-button>
      </el-form>    
      <div style="height:20px;">&nbsp;</div>
    </div>
    <DiluTable :list="tableData" :tableConfig="tableConfig">
        <el-table-column prop="meter" label="电表ID" width="100" align="left" />
        <el-table-column prop="meterName" label="电表名称" width="150" align="left" />
        <el-table-column prop="parent" label="父电表ID" width="110" align="left" />
        <el-table-column prop="parentName" label="父电表名称" width="150" align="left" />
        <el-table-column prop="nodeFlag" label="分项电表" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.nodeFlag == 'yes'">是</span>
            <span v-if="scope.row.nodeFlag == 'no'">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="150" align="left" />
        <el-table-column prop="updatedAt" label="更新时间" width="150" align="left" />
        <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
                <div class="table-operation">
                    <el-button @click="edit(scope.row)" type="text">编辑</el-button>
                </div>
            </template>
        </el-table-column>
    </DiluTable>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import DiluTable from "@/components/public/dilu-table.vue";
export default {
  data() {
    return {
      ruleForm: {
        project: null,
        meter: null,
        parent: null,
        nodeFlag: null,
      },
      parentVisible: false,
      tableConfig: {
          isTree: false,
          isPage: false,
      },
      tableData: [],
      parentList: []
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  components: {
    DiluTable
   },
  props: ["meterVisible","project"],
  watch: {
    meterVisible(newValue) {
      if (newValue) {
        this.ruleForm.project=this.project;
        this.meterList();
      }
    },
  },
  methods: {
    meterList() {
        var params={
            project: this.project
        }
        this.request.meterList(params).then((res) => {
            this.tableData = res.data;
            this.parentList = res.data;
        });
    },
    handleClose() {
      this.$emit("handleClose");
    },
    edit(e) {
      this.ruleForm.meter=e.meter;
      this.ruleForm.parent=e.parent;
      this.ruleForm.nodeFlag=e.nodeFlag;
      this.parentVisible=true;
    },
    closeEdit() {
      this.parentVisible=false;
    },
    submit() {
      this.request.meterParent(this.ruleForm).then((res) => {
          if (res.code==0) {
            this.parentVisible=false;
            this.meterList();
          }
      });
    },
  },
};
</script>
<style scoped>
.form-body {
  width:550px;
  display:flex;
  flex-direction:row;
  justify-content:center;
  box-sizing:border-box;
}
</style>